var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_25458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5834 19.1667C32.0751 19.1667 31.5876 18.9647 31.2281 18.6053C30.8687 18.2458 30.6667 17.7583 30.6667 17.25V11.5C30.6687 9.59873 29.964 7.76459 28.6897 6.35361C27.4154 4.94264 25.6622 4.05551 23.7706 3.86444C21.8789 3.67336 19.9838 4.19198 18.453 5.31961C16.9223 6.44723 15.8651 8.10342 15.4867 9.96666C15.3851 10.4651 15.0896 10.9027 14.6653 11.1832C14.2409 11.4638 13.7225 11.5643 13.2241 11.4626C12.7257 11.361 12.2881 11.0655 12.0075 10.6411C11.727 10.2168 11.6265 9.69841 11.7282 9.19999C12.2936 6.40303 13.8788 3.9162 16.1755 2.2228C18.4723 0.529391 21.3166 -0.249634 24.1557 0.0371205C26.9948 0.323875 29.6259 1.65592 31.5377 3.7744C33.4494 5.89287 34.5053 8.64645 34.5001 11.5V17.25C34.5001 17.7583 34.2981 18.2458 33.9387 18.6053C33.5793 18.9647 33.0917 19.1667 32.5834 19.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 17.25H11.5C8.32436 17.25 5.75 19.8244 5.75 23V38.3333C5.75 41.509 8.32436 44.0833 11.5 44.0833H34.5C37.6756 44.0833 40.25 41.509 40.25 38.3333V23C40.25 19.8244 37.6756 17.25 34.5 17.25ZM22.9997 38.3333C22.4913 38.3333 22.0038 38.1314 21.6444 37.772C21.2849 37.4125 21.083 36.925 21.083 36.4167V32.0701C19.9376 31.4072 19.167 30.1686 19.167 28.75C19.167 26.6329 20.8832 24.9167 23.0003 24.9167C25.1174 24.9167 26.8337 26.6329 26.8337 28.75C26.8337 30.1692 26.0625 31.4082 24.9163 32.0709V36.4167C24.9163 36.925 24.7144 37.4125 24.355 37.772C23.9955 38.1314 23.508 38.3333 22.9997 38.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_25458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.889bc2d8091fc3d10140086cffd777fe.svg";
export { ForwardRef as ReactComponent };